import type { FormEvent } from 'react';
import { faMagnifyingGlass } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import type { TextInputProps } from '@/components/ui/form/text-input';
import { TextInput } from '@/components/ui/form/text-input';
import { Icon } from '@/components/ui/icon';
import { cn } from '@/lib/utils';

interface SearchBarProps extends Omit<TextInputProps, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
}

export function SearchBar({
  value,
  onChange,
  onSubmit,
  className,
  leftSection = <Icon icon={faMagnifyingGlass} />,
  placeholder = 'Search...',
  ...textInputProps
}: SearchBarProps) {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit?.();
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextInput
        {...textInputProps}
        leftSection={leftSection}
        placeholder={placeholder}
        value={value}
        className={cn('w-sm md:w-md', className)}
        onChange={(e) => onChange(e.target.value)}
      />
    </form>
  );
}
